import _objectSpread from"/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";/**
 * Dot (filled): a solid circle at the center of the grid — the status-marker
 * form, which only reads right solid.
 *
 * Progress swells it and settles it back. See dotBase for the geometry and the
 * pulse.
 *
 * Color slot: 0 the dot.
 */import*as React from"react";import{DOT_CENTER,pulsedRadius}from"web/shared/icons/glyphs/dotBase";import{fillPalette}from"web/shared/icons/colorVector";import{jsx as _jsx}from"react/jsx-runtime";function DotFilledGlyph(props){// The fill rides the wrapping group, which is the contract every -filled
// glyph follows.
return/*#__PURE__*/_jsx("g",_objectSpread(_objectSpread({},fillPalette(props.colors)[0]),{},{children:/*#__PURE__*/_jsx("circle",{cx:DOT_CENTER,cy:DOT_CENTER,r:pulsedRadius(props.progress)})}));}export default DotFilledGlyph;